import { render, staticRenderFns } from "./Supercell.vue?vue&type=template&id=65c11b47&"
import script from "./Supercell.vue?vue&type=script&lang=js&"
export * from "./Supercell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports